import { queryOptions, useQuery } from '@tanstack/react-query'

import { fetchCurrentUser } from './api'

export const sessionQueryKey = ['auth', 'me'] as const

export const sessionQueryOptions = queryOptions({
  queryKey: sessionQueryKey,
  queryFn: fetchCurrentUser,
  staleTime: 60_000,
})

/** Estado de sessao compartilhado via cache do TanStack Query (sem contexto/estado global extra). */
export function useSession() {
  const query = useQuery(sessionQueryOptions)
  const user = query.data ?? null

  return {
    user,
    isAuthenticated: user !== null,
    isLoading: query.isLoading,
  }
}
